import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CppSRACostSheetGlossarySliderModelService {
  public addProductSlider: BehaviorSubject<boolean>;
  public addSidenav: MatSidenav;
  sliderCloseRqt: Subject<boolean>;

  constructor() {
    this.addProductSlider = new BehaviorSubject(false);
    this.sliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    if (value === 'ShowSRACostSheetGlossary') {
      this.addProductSlider.next(true);
      this.addSidenav.toggle();
    }
  }

  public setSideNav(sideNavObj: MatSidenav) {
    this.addSidenav = sideNavObj;
  }

  public close() {
    this.addProductSlider.next(false);
    this.addSidenav.close();
  }
}
